<template>
  <div>
    <h4>Survey Complete: Fill out the take-away with the information provided below.</h4>
    <hr />
    <b-row>
      <b-col md="8">
          <b-row>
            <b-col md="6" class="text-right">
              <label class="f15em"><strong>Reference Code:</strong></label>
            </b-col>
            <b-col md="2" class="text-left">
              <label class="f15em">{{ surveyData.referenceCode }}</label>
            </b-col>
            <b-col md="2" class="text-right">
              <label class="f15em"><strong>ID:</strong></label>
            </b-col>
            <b-col md="2" class="text-left">
              <label class="f15em">{{ surveyData.id }}</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6" class="text-right">
              <label class="f15em"><strong>Location:</strong></label>
            </b-col>
            <b-col md="6" class="text-left">
              <div v-if="surveyData.location">
                <label class="f15em">{{ surveyData.location.name }}</label>
              </div>
              <!-- <label v-if="!surveyData.location.name == undefined" for>{{ surveyData.location.name }}</label> -->
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6" class="text-right">
              <label class="f15em"><strong>Date:</strong></label>
            </b-col>
            <b-col md="6" class="text-left">
              <label class="f15em">{{ surveyData.dateCreated | moment("MMMM Do YYYY")  }}</label>
            </b-col>
          </b-row>

      </b-col>
      <b-col md="4">
        <div style="padding: 15px;">
          <b-button size="lg" @click="newSurvey">Start Another</b-button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col md="12">
        <b-row style="padding-bottom: 5px;">
            <b-col class="text-left">
              <b>Diabetes Risk Assessment Screening Results</b>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="11" lg="9">

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Diabetes Risk Assessment Score (0-10):</strong><br>
                  4+ score is defined as an "at risk" number
                </b-col>
                <b-col md="2" class="text-left">
                  <label class="f2em">{{ surveyData.totalRiskScore }}</label>
                </b-col>                
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  &nbsp;
                </b-col>  
                <b-col md="2" class="text-left">
                  <strong>Answer</strong>
                </b-col> 
                <b-col md="2" class="text-left">
                  <strong>Points</strong>
                </b-col>              
              </b-row> 
              <hr/>
              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Age: </strong><br>
                  0-39 (0 points)<br>
                  40-49 (1 points)<br>
                  50-59 (2 points)<br>
                  60+ (3 points)
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.age }}</label>
                </b-col> 
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.ageScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Are you a man or a woman?: </strong><br>
                  Man (1 points)<br>
                  Woman (0 points)<br>
                  Other (0 points)
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.gender === 'M' ? 'Man' : surveyData.gender === 'F' ?'Woman' : 'Other' }}</label>
                </b-col> 
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.genderScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>If woman, have you ever been diagnosed with gestational diabetes? </strong><br>
                  Yes (1 points)<br>
                  No (0 points)
                </b-col> 
                <b-col md="2" class="text-left">
                  <label class="f15em">{{surveyData.diagnosedGestationalDiabetes ? 'Yes' : 'No' }}</label>
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.gestationalDiabetesScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Do you have a mother, father, sister, or brother with diabetes? </strong><br>
                  Yes (1 points)<br>
                  No (0 points)
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{surveyData.relativeWithDiabetes ? 'Yes' : 'No' }}</label>
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.relativeWithDiabetesScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Have you ever been diagnosed with high blood pressure? </strong><br>
                  Yes (1 points)<br>
                  No (0 points)
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{surveyData.diagnosedHighBP ? 'Yes' : 'No' }}</label>  
                </b-col> 
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.diagnosedHighBPScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Are you physically active? </strong><br>
                  Yes (0 points)<br>
                  No (1 points)
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{surveyData.physicallyActive ? 'Yes' : 'No' }}</label>
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.physicallyActiveScore }}</label>
                </b-col>              
              </b-row> 

              <b-row>
                <b-col md="8" class="text-left">
                  <strong>Total points for weight? </strong>&nbsp;<font-awesome-icon icon="info-circle" class="fa-1x" v-b-modal.my-modal2/><br> 
                  0 to 3 points
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.heightFeet + "'" + surveyData.heightInches + '"'  }}&nbsp;/&nbsp;{{ surveyData.weight }}&nbsp;lbs</label>
                </b-col>  
                <b-col md="2" class="text-left">
                  <label class="f15em">{{ surveyData.weightScore }}</label>                  
                  <b-modal id="my-modal2"  size="md" ok-only>
                    <weight-table></weight-table>
                  </b-modal>
                </b-col>              
              </b-row> 



            </b-col>   

          </b-row>

      </b-col>   
    </b-row> 
   <hr/>
    <b-row>
      <b-col md="3" class="text-left">
        <strong>Body Mass Index (BMI):</strong>&nbsp;<font-awesome-icon icon="info-circle" class="fa-1x" v-b-modal.my-modal/>
        
                  <b-modal id="my-modal"  size="lg" ok-only>
                    <img src="@/assets/body-mass-index.png" width="725"/>
                  </b-modal>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.bmi }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="text-left">
        <strong>Glucose:</strong>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.glucoseReading }}</label>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col md="3" class="text-left">
        <strong>A1C:</strong>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.a1cnumber }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left">
        <b>Lipids</b>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>TOTAL CHOLESTEROL :</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.lipidsChol }}</label>
      </b-col>
      
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>HDL:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.lipidsHdlC }}</label>
      </b-col>   
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>LDL:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.lipidsLdlC }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>Triglycerides:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.lipidsTrig }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>Total Cholesterol / HDL Ratio:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.lipidsCholHdl }}</label>
      </b-col>     
    </b-row>

    <b-row>
      <b-col class="text-left">
        <b>Blood Pressure</b>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>Systolic:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.bpSystolic }}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="text-right">
        <label class="pt6px"><strong>Diastolic:</strong></label>
      </b-col>
      <b-col md="2" class="text-left">
        <label class="f15em">{{ surveyData.bpDiastolic }}</label>
      </b-col>     
    </b-row>
  </div>
</template>

<script>
import weightTable from "@/components/WeightTable";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

export default {
  name: "surveryfinished",
  props: ["surveyData"],
  methods: {
    newSurvey() {
      this.$emit("move-next");
    },
    previousStep() {
      this.$emit("move-previous");
    }
  },
  components: {
    weightTable,
    FontAwesomeIcon
  }
};
</script>

<style scoped>
.col {
  text-align: left;
}
.row {
  padding-bottom: 5px;
}
.fa-info-circle{
  color: #00a9e0;
}
.f2em {
  font-size: 2em;
}
.f15em{
  font-size: 1.5em;
}
.pt6px {
  padding-top: 6px;
}
</style>